import * as React from 'react'
import { findDOMNode } from 'react-dom'

import SearchLink from '../../../../shared/containers/searchLinkContainer'

import { IRecommendedSearches } from '../../../../../typings/recommendedSearches'
import * as styles from './relatedSearches.module.css'

interface IRelatedSearchItemProps {
  type: string
  term: string
}

interface INextQuery {
  [index: string]: string
}

const RelatedSearchItem = ({ term, type }: IRelatedSearchItemProps) => {
  const nextQuery: INextQuery = {}
  nextQuery[type] = term

  return (
    <li className={styles.listItem}>
      <SearchLink locationParams={nextQuery} className={styles.link}>
        {term}
      </SearchLink>
    </li>
  )
}

const RelatedSearches = ({
  recommendations,
  type,
  hint
}: IRecommendedSearches) => (
  <div className={styles.root}>
    <p className={styles.title}>
      Searches related to
      <span className={styles.bold}> {hint}</span>
    </p>
    {type && (
      <ul className={styles.list}>
        {recommendations.map((term, index) => {
          return <RelatedSearchItem key={index} term={term} type={type} />
        })}
      </ul>
    )}
  </div>
)

export default RelatedSearches
